import { Check } from "lucide-react";
import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";

const ABOUT_IMG =
  "https://images.unsplash.com/photo-1646980241033-cd7abda2ee88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwzfHxwcm9mZXNzaW9uYWwlMjB3b21lbiUyMGNsZWFuZXJzfGVufDB8fHx8MTc4NjM5NjM2MXww&ixlib=rb-4.1.0&q=85";

const POINTS = [
  "Attention to detail in every corner",
  "Reliable service you can count on",
  "Friendly, caring customer service",
  "Professional cleaning, every visit",
  "Pride in every single job",
];

const About = () => (
  <section id="about" className="bg-white py-20 sm:py-24" data-testid="about-section">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-16">
        <Reveal className="relative order-2 lg:order-1">
          <div className="absolute -left-4 -top-4 h-24 w-24 rounded-3xl bg-[#E6E6FA] sm:-left-6 sm:-top-6" aria-hidden="true" />
          <img
            src={ABOUT_IMG}
            alt="Professional cleaner caring for a bright home"
            className="relative w-full rounded-3xl object-cover shadow-[0_8px_30px_rgb(0,0,0,0.08)] sm:aspect-[4/5] lg:max-h-[560px]"
            loading="lazy"
          />
          <div className="absolute -bottom-6 -right-2 rounded-2xl border border-[#D4AF37]/30 bg-white/90 px-6 py-4 shadow-[0_8px_30px_rgb(0,0,0,0.06)] backdrop-blur-md sm:-right-6" data-testid="about-badge">
            <p className="font-script text-2xl text-[#674EA7]">Sisters-owned</p>
            <p className="text-xs font-semibold uppercase tracking-widest text-[#6B6776]">Family business</p>
          </div>
        </Reveal>

        <div className="order-1 lg:order-2">
          <SectionHeader
            eyebrow="About Us"
            title="About Glow & Shine Sisters"
            subtitle="We are a sisters-owned cleaning business devoted to making homes and businesses feel fresh, clean, comfortable, and welcoming. Every space we touch is treated with the same care we give our own."
          />
          <ul className="mt-10 space-y-4" data-testid="about-points">
            {POINTS.map((p, i) => (
              <Reveal key={p} delay={i * 0.08}>
                <li className="flex items-center gap-4">
                  <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-[#E6E6FA]">
                    <Check className="h-4 w-4 text-[#674EA7]" aria-hidden="true" />
                  </span>
                  <span className="text-base font-medium text-[#2C2A35]">{p}</span>
                </li>
              </Reveal>
            ))}
          </ul>
        </div>
      </div>
    </div>
  </section>
);

export default About;
